<template>
    <div class="param">
        <label class="param-label">{{ rotulo }}</label>
        <div class="param-ajuda" v-if="p.descricao">{{ p.descricao }}</div>

        <!-- escolha fixa (o backend manda as opções em /configuracao/parametros) -->
        <el-select v-if="opcoes && opcoes.length" :value="valor" @input="emitir" style="width: 100%; max-width: 520px;">
            <el-option v-for="o in opcoes" :key="o.valor" :label="o.label" :value="o.valor">
                <span>{{ o.label }}</span>
                <span v-if="o.ajuda" class="param-opcao-ajuda">{{ o.ajuda }}</span>
            </el-option>
        </el-select>

        <el-switch v-else-if="p.tipo === 'bool'" :value="!!valor" @change="emitir"
            active-text="Sim" inactive-text="Não"></el-switch>

        <el-input-number v-else-if="p.tipo === 'int'" :value="Number(valor || 0)" @change="emitir"
            :min="min" :max="max" :controls="false" style="width: 160px;"></el-input-number>

        <el-input v-else :value="valor === null ? '' : String(valor)" @input="emitir"
            :placeholder="p.padrao" style="max-width: 520px;"></el-input>

        <div class="param-chave">folha_ponto.{{ p.chave }}</div>
    </div>
</template>

<script>
// Renderiza UM parâmetro da folha de ponto conforme o tipo declarado no catálogo
// do backend. O pai é quem guarda o valor e persiste — aqui só há edição.
export default {
    name: 'ParamEditor',
    props: {
        p: { type: Object, required: true },
        valor: { default: null },
        rotulo: { type: String, default: '' },
        opcoes: { type: Array, default: null },
        min: { type: Number, default: 0 },
        max: { type: Number, default: 999999 }
    },
    methods: {
        emitir (v) {
            this.$emit('input', v)
        }
    }
}
</script>

<style scoped>
.param { padding: 14px 0; border-bottom: 1px solid #f0f0f0; }
.param-label { display: block; font-weight: 600; color: #303133; margin-bottom: 2px; }
.param-ajuda { color: #909399; font-size: 12px; margin-bottom: 8px; line-height: 1.5; }
.param-chave { color: #c0c4cc; font-size: 11px; margin-top: 5px; font-family: monospace; }
.param-opcao-ajuda { display: block; color: #909399; font-size: 11px; line-height: 1.4; white-space: normal; }
</style>
